// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles-module__tabs___3NW0y"};